import { render, staticRenderFns } from "./Account.vue?vue&type=template&id=6d706421&scoped=true"
import script from "./Account.vue?vue&type=script&lang=ts"
export * from "./Account.vue?vue&type=script&lang=ts"
import style0 from "./Account.vue?vue&type=style&index=0&id=6d706421&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d706421",
  null
  
)

export default component.exports